import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useNavigate } from '@tanstack/react-router';
import { GridActionsCell, GridActionsCellItem } from '@mui/x-data-grid/components';
import { useLingui } from '@lingui/react/macro';
import { GridRenderCellParams } from '@mui/x-data-grid/models';
import { DispenserListItem } from '@/features/dispensers/services/schemas.ts';

export const ActionsCell = (props: GridRenderCellParams<DispenserListItem>) => {
  const navigate = useNavigate();
  const { t } = useLingui();

  return (
    <GridActionsCell {...props}>
      <GridActionsCellItem
        label={t`Detail`}
        icon={<VisibilityOutlinedIcon />}
        onClick={() =>
          navigate({
            to: '/dispensers/$dispenserId',
            params: { dispenserId: `${props.row.id}` },
          })
        }
      />
    </GridActionsCell>
  );
};
